import { render } from "./CollegeEntry.vue?vue&type=template&id=dda6f978&scoped=true"
import script from "./CollegeEntry.vue?vue&type=script&lang=ts"
export * from "./CollegeEntry.vue?vue&type=script&lang=ts"

import "./CollegeEntry.vue?vue&type=style&index=0&id=dda6f978&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-dda6f978"

export default script